export const matchColumnStyle = {
	textWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '12px',
		background: 'var(--info-100)',
		padding: '8px 16px',
		borderRadius: '8px',
		margin: '0 auto',
		width: '360px',
		whiteSpace: 'nowrap',
		marginBottom: '24px',
	},

	buttonWrapper: {
		position: 'fixed',
		bottom: '24px',
		// left: '0px',
		// right: '0px',
		maxWidth: '1170px',
		width: '100%',
		height: '80px',
		padding: '20px 100px',
		left: 'calc(50% - 585px)',
		background: 'var(--neutral-100)',
		borderRadius: '0 0 8px 8px',
	},

	titleWrapper: {
		display: 'flex',
		gap: '24px',
		margin: '0 auto',
		marginBottom: '12px',
		width: '500px',
	},

	title: {
		fontWeight: 'bold',
		width: '256px',
	},

	columnTitle: {
		width: '210px',
	},

	select: {
		width: '220px',
	},

	optionsWrapper: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '24px',
		paddingBottom: '100px',
	},

	option: {
		position: 'relative',
		borderRadius: '8px',
		border: '1px solid var(--neutral-100)',
		padding: '16px',
		width: '503px',
	},

	recommended: {
		position: 'absolute',
		top: '16px',
		right: '16px',
		color: 'var(--primary-500)',
	},

	optionTextWrapper: {
		display: 'flex',
		gap: '12px',
		alignItems: 'center',
		marginBottom: '8px',
	},

	mainText: {
		fontWeight: 'bold',
	},

	text: {
		color: 'var(--neutral-300)',
		fontWeight: 'regular',
	},

	selectItem: {
		width: '430px',
		marginLeft: '40px',
	},

	warningIcon: {
		width: '100%',
		height: '100%',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 20px',
			width: '100%',

			'& > div': {
				width: '100%',
				maxWidth: '370px',
				margin: '0 auto',

				'&> div svg path': {
					fill: 'var(--warning-500)',
				},
			},
		},
	},

	active: {
		border: '1px solid var(--primary-500)',
	},
};
